import React from 'react';
import { SideBarItems } from 'components/Sidebar';
import { ConfirmationNumberOutlined, ChatOutlined, EmailOutlined } from '@mui/icons-material';
import { HeadsetMic } from '@mui/icons-material';
import { MyTickets, Chat, SupportEmail } from 'modules/Support';

export const ModulesMenu: SideBarItems[] = [
{
    path: "/",
    urlKey: "support",
    text: "Support",
    icon: <HeadsetMic />,
    type: "menuHeader",
    menuKey: "campaignKing",
    dictionaryKey: "sidebar-menu-support",
    items: [
        {
            path: "/support/",
            urlKey: "my-tickets",
            text: "My Tickets",
            icon: <ConfirmationNumberOutlined />,
            type: "menuItem",
            menuKey: "campaignKing",
            module: <MyTickets />,
            dictionaryKey: "sidebar-menu-support-my-tickets",
        },
        {
            path: "/support/",
            urlKey: "chat",
            text: "Chat",
            icon: <ChatOutlined />,
            type: "menuItem",
            menuKey: "campaignKing",
            module: <Chat />,
            premiumLicenseTypes: ["BusinessPlus", "Enterprise"],
            dictionaryKey: "sidebar-menu-support-chat",
        },
        {
            path: "/support/",
            urlKey: "email",
            text: "Email",
            icon: <EmailOutlined />,
            type: "menuItem",
            menuKey: "campaignKing",
            module: <SupportEmail />,
            dictionaryKey: "sidebar-menu-support-email",
        },
    ]
},
{
    path: "/",
    urlKey: "support",
    text: "Support",
    icon: <HeadsetMic />,
    type: "menuHeader",
    menuKey: "instantUpdate",
    dictionaryKey: "sidebar-menu-support",
    items: [
        {
            path: "/support/",
            urlKey: "my-tickets",
            text: "My Tickets",
            icon: <ConfirmationNumberOutlined />,
            type: "menuItem",
            menuKey: "instantUpdate",
            module: <MyTickets />,
            dictionaryKey: "sidebar-menu-support-my-tickets",
        },
        {
            path: "/support/",
            urlKey: "chat",
            text: "Chat",
            icon: <ChatOutlined />,
            type: "menuItem",
            menuKey: "instantUpdate",
            module: <Chat />,
            premiumLicenseTypes: ["BusinessPlus", "Enterprise"],
            dictionaryKey: "sidebar-menu-support-chat",
        },
        {
            path: "/support/",
            urlKey: "email",
            text: "Email",
            icon: <EmailOutlined />,
            type: "menuItem",
            menuKey: "instantUpdate",
            module: <SupportEmail />,
            dictionaryKey: "sidebar-menu-support-email",
        },
    ]
},
{
    path: "/",
    urlKey: "support",
    text: "Support",
    icon: <HeadsetMic />,
    type: "menuHeader",
    menuKey: "anamnesis",
    dictionaryKey: "sidebar-menu-support",
    items: [
        {
            path: "/support/",
            urlKey: "my-tickets",
            text: "My Tickets",
            icon: <ConfirmationNumberOutlined />,
            type: "menuItem",
            menuKey: "anamnesis",
            module: <MyTickets />,
            dictionaryKey: "sidebar-menu-support-my-tickets",
        },
        {
            path: "/support/",
            urlKey: "email",
            text: "Email",
            icon: <EmailOutlined />,
            type: "menuItem",
            menuKey: "anamnesis",
            module: <SupportEmail />,
            dictionaryKey: "sidebar-menu-support-email",
        },
    ]
},
{
    path: "/",
    urlKey: "support",
    text: "Support",
    icon: <HeadsetMic />,
    type: "menuHeader",
    menuKey: "infralytiqs",
    dictionaryKey: "sidebar-menu-support",
    items: [
        {
            path: "/support/",
            urlKey: "my-tickets",
            text: "My Tickets",
            icon: <ConfirmationNumberOutlined />,
            type: "menuItem",
            menuKey: "infralytiqs",
            module: <MyTickets />,
            dictionaryKey: "sidebar-menu-support-my-tickets",
        },
        {
            path: "/support/",
            urlKey: "email",
            text: "Email",
            icon: <EmailOutlined />,
            type: "menuItem",
            menuKey: "infralytiqs",
            module: <SupportEmail />,
            dictionaryKey: "sidebar-menu-support-email",
        },
    ]
}];
